<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import { JokyGetScreen } from "@/joky";
export default {
  name: "App",
  created() {
    JokyGetScreen();
    window.onresize = () => {
      return (() => {
        JokyGetScreen();
      })();
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue